import React, { useState, useEffect } from 'react'
import AppBar from './AppBar/AppBar'
import linkData from './siteList.json'

console.log(linkData)

const App = () => {
  const [links, setLinks] = useState(linkData)
  
  return <AppBar appName="BDlytics" user="Warren Hall" search appLinks={links} />
}

export default App
